export enum LawPersonListControlName {
  SelectedLawPersons = 'selectedLawPersons'
}
